import { render, staticRenderFns } from "./InviteFriend.vue?vue&type=template&id=bceef856&"
import script from "./InviteFriend.vue?vue&type=script&lang=js&"
export * from "./InviteFriend.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports